import './sharing-icons.scss';

/**
 * version    1.0
 * class      SharingIcons
 * classdesc  Main Sharing Icons
 */
export class SharingIcons {
  constructor() {
    this.init();
  }

  init() {
    // Seleziona tutte le icone di condivisione
    document.querySelectorAll('.sharing-icons__container a').forEach((icon) => {
      icon.addEventListener('click', (e) => this.handleShareClick(e, icon));
    });
  }

  handleShareClick(event, icon) {
    event.preventDefault();

    const platform = this.getPlatform(icon);
    const card = icon.closest('.news-card');
    const url = (card && card.dataset.url) ? card.dataset.url : window.location.href;

    const shareUrl = this.buildShareUrl(platform, url);
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener');
    } else {
      // eslint-disable-next-line no-console
      console.error(`Piattaforma "${platform}" non gestita`);
    }
  }

  getPlatform(icon) {
    if (icon.classList.contains('icon-linkedin-white')) return 'linkedin';
    if (icon.classList.contains('icon-facebook-white')) return 'facebook';
    if (icon.classList.contains('icon-x-white')) return 'x';
    return null;
  }

  buildShareUrl(platform, url) {
    switch (platform) {
      case 'linkedin':
        return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
      case 'x':
        return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
      default:
        return null;
    }
  }
}
